import React, { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import ListReport from './component/listReport';
import {
    useParams
} from "react-router-dom";
import { getSitecode, getTokenData } from '../parseJWT';
export default function Mainreport() {

    const { id } = useParams();

    // Check if token is expired
    const tokenData = getTokenData();
    const isTokenExpired = !!(tokenData && tokenData.exp && (tokenData.exp * 1000 < Date.now()));

    // Safely get SITECODE with error handling
    const userSitecode = getSitecode();

    // Redirect เป็น side effect หลัง render (ห้าม return ก่อนเรียก hook)
    useEffect(() => {
        if (isTokenExpired) {
            console.error('❌ Token expired, please login again');
            localStorage.removeItem('Token');
            window.location.href = '/';
        }
    }, [isTokenExpired]);

    useEffect(() => {
        if (!isTokenExpired && !userSitecode) {
            console.warn('⚠️ Missing SITECODE in token');
        }
    }, [isTokenExpired, userSitecode]);

    if (isTokenExpired) {
        return null;
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <ListReport cateID={id} userSitecode={userSitecode} />
        </React.Fragment>
    );
}
